/* By Old Money cart drawer controller.
   Replaces Dawn's cart-drawer.js. Keeps the API Dawn's product form calls
   (getSectionsToRender, setActiveElement, renderContents) and speaks the events
   the By Old Money drawer code listens for:
     cart:build      -> line items need re-rendering
     cart:updated    -> {detail:{cart}} totals, savings, progress
     ajaxProduct:added, drawerOpen.CartDrawer, drawerClose.CartDrawer */
(function () {
  'use strict';

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function fetchJSON(url, opts) {
    return fetch(url, opts).then(function (r) {
      if (!r.ok) return r.json().catch(function () { return {}; }).then(function (e) { throw e; });
      return r.json();
    });
  }

  class BomCartDrawer extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this.drawer = this.querySelector('#CartDrawer');
      this.form = this.querySelector('#CartDrawerForm');

      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-bom-drawer-close], .js-drawer-close')) { e.preventDefault(); this.close(); }
      });
      this.addEventListener('keyup', (e) => { if (e.code === 'Escape') this.close(); });
      document.addEventListener('keyup', (e) => { if (e.code === 'Escape' && this.classList.contains('is-open')) this.close(); });

      /* quantity -/+ and typed quantities on line items */
      this.addEventListener('click', (e) => {
        var btn = e.target.closest('.js-qty__adjust');
        if (!btn || !this.contains(btn)) return;
        e.preventDefault();
        var wrap = btn.closest('.js-qty__wrapper');
        var input = wrap && wrap.querySelector('.js-qty__num');
        if (!input) return;
        var qty = parseInt(input.value, 10) || 0;
        qty = btn.classList.contains('js-qty__adjust--plus') ? qty + 1 : Math.max(0, qty - 1);
        input.value = qty;
        this.changeQty(input.dataset.id, qty, btn.closest('.cart-item-custom'));
      });
      this.addEventListener('change', (e) => {
        var input = e.target.closest('.js-qty__num');
        if (!input || !this.contains(input)) return;
        var qty = Math.max(0, parseInt(input.value, 10) || 0);
        this.changeQty(input.dataset.id, qty, input.closest('.cart-item-custom'));
      });

      /* header cart icon opens the drawer instead of going to /cart */
      document.addEventListener('click', (e) => {
        var icon = e.target.closest('#cart-icon-bubble, .js-drawer-open-cart');
        if (!icon) return;
        e.preventDefault();
        this.setActiveElement(icon);
        this.open();
      });

      /* things outside the drawer that add to the cart (sticky bar, upsell) */
      document.addEventListener('ajaxProduct:added', () => {
        this.refresh().then(() => this.open());
      });
      document.addEventListener('cart:build', () => { this.renderItems(); this.refreshCartPage(); });

      /* the /cart page uses the same line items and summary as the drawer */
      document.addEventListener('click', (e) => {
        var btn = e.target.closest('.bom-cartpage .js-qty__adjust');
        if (!btn) return;
        e.preventDefault();
        var input = btn.closest('.js-qty__wrapper').querySelector('.js-qty__num');
        var qty = parseInt(input.value, 10) || 0;
        qty = btn.classList.contains('js-qty__adjust--plus') ? qty + 1 : Math.max(0, qty - 1);
        input.value = qty;
        this.changeQty(input.dataset.id, qty, btn.closest('.cart-item-custom'));
      });
      document.addEventListener('change', (e) => {
        var input = e.target.closest('.bom-cartpage .js-qty__num');
        if (!input) return;
        this.changeQty(input.dataset.id, Math.max(0, parseInt(input.value, 10) || 0), input.closest('.cart-item-custom'));
      });

      /* Eerste vulling. De lade rendert zijn regels uit /cart.js en niet uit
         Liquid, dus zonder deze aanroep staat hij leeg tot er iets verandert:
         openen via het tas-icoon liet een lege lade zien terwijl de tas gevuld
         was. cart-drawer-extension stuurt wel 'cart:build', maar pas op
         DOMContentLoaded - en dat is te laat als dit element later upgradet. */
      if (this.querySelector('[data-products]')) this.renderItems();

      /* a cart changed elsewhere (Dawn pub/sub) */
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'bom-cart-drawer' || event.source === 'product-form') return;
          this.refresh();
        });
      }
    }

    /* ---- API used by Dawn's product-form.js ---- */
    getSectionsToRender() { return [{ id: 'cart-icon-bubble', selector: '.shopify-section' }]; }
    setActiveElement(el) { this.activeElement = el; }
    renderContents(parsedState) {
      this.classList.remove('is-empty');
      this.renderBubble(parsedState && parsedState.sections && parsedState.sections['cart-icon-bubble']);
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: parsedState } }));
    }

    /* ---- open / close ---- */
    open() {
      if (this.classList.contains('is-open')) return;
      this.classList.add('is-open');
      document.body.classList.add('js-drawer-open', 'js-drawer-open-right', 'overflow-hidden');
      if (this.drawer) {
        this.drawer.classList.add('drawer--is-open');
        setTimeout(() => { try { this.drawer.focus({ preventScroll: true }); } catch (e) {} }, 50);
      }
      document.dispatchEvent(new CustomEvent('drawerOpen.CartDrawer'));
    }
    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      document.body.classList.remove('js-drawer-open', 'js-drawer-open-right', 'overflow-hidden');
      if (this.drawer) this.drawer.classList.remove('drawer--is-open');
      if (this.activeElement && this.activeElement.focus) this.activeElement.focus({ preventScroll: true });
      document.dispatchEvent(new CustomEvent('drawerClose.CartDrawer'));
    }

    /* ---- rendering ---- */
    renderBubble(html) {
      var target = document.getElementById('cart-icon-bubble');
      if (!target || !html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.getElementById('cart-icon-bubble') || doc.querySelector('.shopify-section');
      if (fresh) target.innerHTML = fresh.innerHTML;
    }
    renderItems() {
      var holder = this.querySelector('[data-products]');
      if (!holder) return Promise.resolve();
      return fetch(ROOT + 'cart?view=ajax', { credentials: 'same-origin' })
        .then((r) => r.text())
        .then((html) => {
          holder.innerHTML = html;
          var list = holder.querySelector('.cart__items');
          var count = list ? parseInt(list.getAttribute('data-count') || '0', 10) : 0;
          this.classList.toggle('is-empty', count === 0);
          if (this.form) this.form.classList.toggle('is-empty', count === 0);
          var sub = this.querySelector('[data-subtotal]');
          if (sub && list) sub.textContent = list.getAttribute('data-cart-subtotal') || sub.textContent;
        });
    }
    refreshCartPage() {
      var page = document.querySelector('.bom-cartpage');
      var section = page && page.closest('.shopify-section');
      if (!section) return Promise.resolve();
      var id = section.id.replace('shopify-section-', '');
      return fetch(window.location.pathname + '?sections=' + encodeURIComponent(id), { credentials: 'same-origin' })
        .then((r) => r.json())
        .then((data) => {
          var doc = new DOMParser().parseFromString(data[id], 'text/html');
          var fresh = doc.querySelector('.bom-cartpage');
          if (fresh) page.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    }
    refreshBubble() {
      return fetch(ROOT + '?sections=cart-icon-bubble', { credentials: 'same-origin' })
        .then((r) => r.json())
        .then((s) => this.renderBubble(s['cart-icon-bubble']))
        .catch(function () {});
    }
    refresh() {
      return Promise.all([this.renderItems(), this.refreshBubble()])
        .then(() => fetchJSON(ROOT + 'cart.js', { credentials: 'same-origin' }))
        .then((cart) => {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          return cart;
        })
        .catch(function () {});
    }
    changeQty(key, qty, row) {
      if (!key) return;
      if (row) row.classList.add('is-loading');
      clearTimeout(this._qtyT);
      this._qtyT = setTimeout(() => {
        fetchJSON(ROOT + 'cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        })
          .then((cart) => Promise.all([this.renderItems(), this.refreshBubble(), this.refreshCartPage()]).then(() => cart))
          .then((cart) => {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bom-cart-drawer', cartData: cart });
            }
          })
          .catch((err) => {
            if (row) row.classList.remove('is-loading');
            var msg = (err && (err.description || err.message)) || '';
            if (msg) window.alert(msg);
            this.renderItems();
          });
      }, 250);
    }
  }

  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', BomCartDrawer);

  /* money formatting the By Old Money drawer code expects on window.theme */
  window.theme = window.theme || {};
  if (!window.theme.Currency) {
    window.theme.Currency = {
      formatMoney: function (cents, format) {
        if (typeof cents === 'string') cents = cents.replace('.', '');
        var value = '';
        var re = /\{\{\s*(\w+)\s*\}\}/;
        /* De laatste terugval stond op '${{amount}}' en zette dus een DOLLARteken
           op een winkel die in euro's verkoopt zodra window.theme.moneyFormat er
           om wat voor reden niet is. Zonder symbool is fout-maar-niet-misleidend;
           snippets/bom-head.liquid zet het echte formaat uit shop.money_format. */
        var fmt = format || window.theme.moneyFormat || '{{amount_with_comma_separator}}&nbsp;€';
        function fmtNum(number, precision, thousands, decimal) {
          thousands = thousands || ','; decimal = decimal || '.';
          if (isNaN(number) || number == null) return '0';
          number = (number / 100.0).toFixed(precision);
          var parts = number.split('.');
          var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
          var c = parts[1] ? decimal + parts[1] : '';
          return dollars + c;
        }
        var m = fmt.match(re);
        switch (m && m[1]) {
          case 'amount': value = fmtNum(cents, 2); break;
          case 'amount_no_decimals': value = fmtNum(cents, 0); break;
          case 'amount_with_comma_separator': value = fmtNum(cents, 2, '.', ','); break;
          case 'amount_no_decimals_with_comma_separator': value = fmtNum(cents, 0, '.', ','); break;
          default: value = fmtNum(cents, 2);
        }
        return fmt.replace(re, value);
      }
    };
  }
})();
